export default class OpenConversations {
  constructor(context) {
    this.context = context;
  }

  run({ timezone }) {
    this.context.stores.embedTokensConversations.setLoading();
    this.context.gateways.embedTokensConversations.add({ type: 'conversations' }, { timezone });
  }
}
